/**
 * Big-blind formatting helpers. Tournament pros read amounts in BBs —
 * "6BB raise" is instantly legible, "120" needs mental math. We keep
 * chip counts as the canonical unit in state/engine (never touch the
 * engine) and render BB everywhere in UI.
 */

/**
 * Format a chip amount as a BB string: "6BB", "12.5BB", "0.4BB".
 * Returns "—" when bb size is unknown (pre-hand / between tournaments).
 */
export function toBB(chips: number, bbSize: number): string {
  if (!bbSize || bbSize <= 0) return '—';
  const bb = chips / bbSize;
  if (bb >= 10) return `${Math.round(bb)} BB`;
  const oneDecimal = Math.round(bb * 10) / 10;
  return `${Number.isInteger(oneDecimal) ? oneDecimal.toFixed(0) : oneDecimal.toFixed(1)} BB`;
}

/**
 * Snap a raise amount to BB-granularity (rounding to nearest half BB).
 * Keeps the ActionBar slider feeling discrete and intentional instead of
 * one-chip-at-a-time scroll.
 */
export function snapRaiseToBB(chips: number, bbSize: number): number {
  if (!bbSize || bbSize <= 0) return chips;
  const halfBB = bbSize / 2;
  return Math.round(chips / halfBB) * halfBB;
}
